import { createAppTheme } from './createAppTheme';

/** The light theme (default). */
export const theme = createAppTheme('light');
